import { useContext } from "react";
import { ChakraProvider } from "@chakra-ui/react"

import { ClientContext } from "context/ClientContext"

import baseTheme from "./base"
import BaseFonts from "./base/Fonts"
import creightonTheme from "./creighton"
import CreightonFonts from "./creighton/Fonts"
import hollinsTheme from "./hollins"
import HollinsFonts from "./hollins/Fonts"
import sienaTheme from "./siena"
import SienaFonts from "./siena/Fonts"
import vanguardTheme from "./vanguard"
import VanguardFonts from "./vanguard/Fonts"

const STYLES = {
  base: {
    theme: baseTheme,
    Fonts: BaseFonts,
  },
  siena: {
    theme: sienaTheme,
    Fonts: SienaFonts,
  },
  vanguard: {
    theme: vanguardTheme,
    Fonts: VanguardFonts,
  },
  creighton: {
    theme: creightonTheme,
    Fonts: CreightonFonts,
  },
  hollins: {
    theme: hollinsTheme,
    Fonts: HollinsFonts,
  },
} as const

const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const { client } = useContext(ClientContext)

  const ClientStyles = STYLES[client?.theme ?? "base"]

  return (
    <ChakraProvider theme={ClientStyles.theme}>
      <ClientStyles.Fonts />
      {children}
    </ChakraProvider>
  )
}

export default ThemeProvider